import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { blogPosts } from '../blogData';
import { Helmet } from "react-helmet"; // SEO Tags ke liye

const Blog = () => {
  return (
    <div className="bg-white text-gray-900 min-h-screen pt-24 pb-16 px-6">
      {/* --- SEO HELMET FOR WORLDWIDE REACH --- */}
      <Helmet>
        <title>ZYGMA Insights | Global SEO, GMB & Digital Marketing Blog</title>
        <meta name="description" content="Stay updated with the latest worldwide trends in SEO, Google Business Profile optimization, and digital growth strategies. Expert insights from the ZYGMA team." />
        <meta name="keywords" content="Digital Marketing Blog, Global SEO Tips, GMB Optimization Guide, Worldwide Business Growth, ZYGMA Insights" />
        <link rel="canonical" href="https://zygmagrowthsolutions.com/blog" />
      </Helmet>

      <div className="max-w-7xl mx-auto">
        
        {/* Header Section */}
        <div className="text-center mb-16">
          <motion.h1 
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-5xl md:text-7xl font-black mb-4 tracking-tighter"
          >
            ZYGMA <span className="text-blue-600">Insights</span>
          </motion.h1>
          <p className="text-gray-500 text-lg max-w-2xl mx-auto">
            Latest industry secrets to scale your business <span className="text-blue-600 font-bold">worldwide</span>.
          </p>
        </div>

        {/* Blog Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts.map((post, i) => (
            <motion.div 
              key={post.slug}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="relative group min-h-[420px] rounded-[2.5rem] overflow-hidden shadow-2xl bg-slate-900 flex flex-col justify-end p-8 border border-slate-800 hover:border-blue-500/50 transition-all duration-500"
            >
              {/* Background Image with Overlay */}
              <div className="absolute inset-0 z-0">
                <img 
                  src={post.image || "https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=2026"} 
                  alt={post.title} // SEO: Image alt text
                  className="w-full h-full object-cover opacity-30 group-hover:scale-110 group-hover:opacity-40 transition-all duration-700" 
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/70 to-transparent"></div>
              </div>

              {/* Content Area */}
              <div className="relative z-10">
                <span className="bg-blue-600/20 text-blue-400 border border-blue-500/30 px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-widest mb-4 inline-block">
                  {post.date}
                </span>
                
                {/* SEO: H2 for Blog Titles is perfect */}
                <h2 className="text-2xl font-black text-white leading-tight mb-4 group-hover:text-blue-400 transition-colors">
                  {post.title}
                </h2>
                
                <p className="text-gray-400 text-sm line-clamp-2 mb-6 leading-relaxed">
                  {post.excerpt}
                </p>

                <Link 
                  to={`/blog/${post.slug}`} 
                  className="inline-block bg-white text-slate-900 px-6 py-2.5 rounded-xl font-bold text-xs uppercase tracking-tighter hover:bg-blue-600 hover:text-white transition-all transform active:scale-95 shadow-lg"
                >
                  Read Article
                </Link>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Blog;